<template>
  <li class="py-4 flex items-center space-x-3">
    <img v-if="hasPreview || isImage" class="h-10 w-10 rounded-full" :src="previewUrl" alt="" />
    <div class="flex-1 w-0">
      <p class="text-sm font-medium text-gray-900 truncate">
        {{ temporaryMediaUpload.fileName }}
      </p>
      <p class="text-sm text-gray-500">size: {{ formattedFileSize }}</p>
      <div class="mt-2">
        <BaseFormInput v-model="dataCollectionName" />
      </div>
    </div>
    <div>
      <button
        type="button"
        :disabled="disabled || loading"
        class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-red-300 text-sm leading-5 font-medium rounded-full text-red-700 bg-white hover:bg-red-50 disabled:border-gray-300 disabled:text-gray-700 disabled:bg-gray-100 disabled:pointer-default"
        @click="removeTemporaryMediaUpload"
      >
        Remove
        <svg
          v-if="loading"
          class="animate-spin -mr-1 ml-3 h-4 w-4 text-gray-700"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2
            5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </button>
    </div>
  </li>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    temporaryMediaUpload: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({
        collectionName: null,
      }),
    },
    disabled: Boolean,
    onRemove: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    dataCollectionName: {
      get() {
        return this.data.collectionName;
      },
      set(collectionName) {
        this.$emit('update:data', {
          ...this.data,
          collectionName,
        });
      },
    },
    isImage() {
      return this.temporaryMediaUpload.mimeType.indexOf('image/') === 0;
    },
    hasPreview() {
      return typeof this.temporaryMediaUpload.previewUrl === 'string';
    },
    previewUrl() {
      if (this.hasPreview) {
        return this.temporaryMediaUpload.previewUrl;
      }

      if (this.isImage) {
        return this.temporaryMediaUpload.url;
      }

      return null;
    },
    formattedFileSize() {
      return Numbro(this.temporaryMediaUpload.size || 0).format({
        output: 'byte',
        base: 'binary',
        mantissa: 1,
        spaceSeparated: true,
      });
    },
  },
  methods: {
    async removeTemporaryMediaUpload() {
      this.loading = true;

      await this.onRemove(this.temporaryMediaUpload).catch(() => {
        this.loading = false;
      });

      this.loading = false;
    },
  },
};
</script>
